//sortingOption: available sorting options are - "title", "created", "price", "discount", "relevance", "sales_amount";
//sortingOrder: available sorting orders are - "asc" (stands for ascending), "desc" (stands for descending);

document.addEventListener('Searchanise.Loaded', function() {
    (function($) {
        let snizeFakeResults = [];
        let snizeSuggestionsCount = Searchanise.GetWidgets().options.AutocompleteSuggestionCount;            
        let isNothingFound = false;
    
        async function insertFakeResults(container, input) {
            if (!snizeFakeResults.length) {
                // you can change collection handle after "collection=" to change from which coll to take the products 
                $('.snize-ac-results-content:not(.hidden)').addClass('hidden');
                     await $.get('https://searchserverapi.com/getresults?api_key=1B1W8j6H2t&sortBy=relevance&sortOrder=desc&items=true&facets=false&collection=top-10-products', function(data) {
                    snizeFakeResults = JSON.parse(data).items;
                });
            }
            
            $('.snize-ac-results-content.hidden').removeClass('hidden');
    
            if (
                isNothingFound
                || (window.innerWidth > 769 && !input.prop('value'))
                || (window.innerWidth < 769 && !$('#snize-mobile-search-input').val())
            ) {
                $('.snize-no-products-found').remove();
                if (!$('#snize-ac-items-container-4 .snize-label', container).length) {
                    $('#snize-ac-items-container-4', container).prepend(`<span class="snize-label">Top Trending</span>`);
                } else {
                    $('#snize-ac-items-container-4 .snize-label', container).text('Top Trending');
                }
    
                snizeFakeResults.forEach((item) => {
                    if ($('.snize-product', container).length == Searchanise.GetWidgets().options.AutocompleteItemCount) {
                        return;
                    }
                    if (window.innerWidth > 1024) {
                        $('#snize-ac-items-container-4', container).append(
                        `<li class="snize-product" id="snize-ac-product-${item.product_id}" style="cursor: pointer;"><a href=${item.link} class="snize-item" draggable="false"><div class="snize-thumbnail"><img src=${item.image_link} class="snize-item-image " alt="${item.title}"></div><span class="snize-title">${item.title}</span>${Searchanise.GetWidgets().render_tpl(Searchanise.GetWidgets().options.AutocompleteReviewsHTML, item)}<span class="snize-description" style="max-height: 2.8em; -webkit-line-clamp: 2;">${item.description}</span><div class="snize-price-list"><span class="snize-price snize-price-with-discount money ">${Searchanise.GetWidgets().formatPrice(item.price)}</span></div></a></li>`).data({snize_item_data: item});
                    } else {
                        $('#snize-ac-items-container-4', container).append(
                        `<li class="snize-product" id="snize-ac-product-${item.product_id}" style="cursor: pointer;"><a href="${item.link}" class="snize-item"><div class="snize-thumbnail"><img src="${item.image_link}" class="snize-item-image " alt="${item.title}"></div><div class="snize-product-info"><span class="snize-title">${item.title}</span>${Searchanise.GetWidgets().render_tpl(Searchanise.GetWidgets().options.AutocompleteReviewsHTML, item)}<span class="snize-description" style="max-height: 2.8em; -webkit-line-clamp: 2;">${item.description}</span><div class="snize-ac-prices-container"><div class="snize-price-list"><span class="snize-price snize-price-with-discount money theme-money ">${Searchanise.GetWidgets().formatPrice(item.price)}</span></div></div></div></a></li>`);
                    }
                });
                $('.snize-ac-results-columns', container).removeClass('snize-hidden');
                $('#snize-ac-items-container-4', container).removeClass('snize-hidden');
                $('#snize-ac-items-container-2', container).removeClass('snize-hidden');  
            } else {
                $('#snize-ac-items-container-4 .snize-label', container).text('Products');
            }
        }
        
        $(document).on('Searchanise.DataRequestEnd', function(event, type, params, data) {
            if (params.q && !data.items.length) {
                isNothingFound = true;
            }
        });
        
        $(document).on("Searchanise.AutocompleteUpdated", function(event, input, container) {
            insertFakeResults(container, input);
    
            if (!$('.snize-suggestion').length) {
                $('#snize-ac-items-container-2', container).addClass('snize-suggestions-modified').append(`<li class="snize-label">POPULAR SEARCHES</li>`);
    
                Searchanise.preloadedSuggestions.forEach((item, index) => {
                    if(index < Number(snizeSuggestionsCount)) {
                        let oddOrEven = (index + 1) % 2 ? 'snize-ac-odd' : 'snize-ac-even'; 
                        $('#snize-ac-items-container-2.snize-suggestions-modified').append(`<li class="snize-suggestion ${oddOrEven}" style="cursor: pointer;">${item}</li>`);
                    }
                });
                
                $('.snize-suggestions-modified').on('click', (e) => {
                    if(e.target.className.includes('snize-suggestion')) {
                        input[0].value = e.target.innerText;
                        let searchQuery = encodeURI(e.target.innerText);
                        window.location.href = 'https://a5aec8.myshopify.com/pages/search-results-page?q=' + searchQuery;
                    }
                });
                
                $('.snize-suggestions-modified').on('mouseout', (e) => {
                    if(e.target.className.includes('snize-suggestion')) {
                        e.target.classList.remove('snize-ac-over-nodrop-mouse');
                        e.target.classList.remove('snize-ac-over-nodrop');
                    }
                });
            } else {
                $('#snize-ac-items-container-2', container).removeClass('snize-suggestions-modified');
            }
            
        });
    })(window.Searchanise.$);
});